/**
 *
 * Este es player controls TV para caneles SIN timeshift
 *
 */
import React, { Component } from 'react';
import './styles/player-controls-live.css';
import ChannelInfoLabel from './common/ChannelInfoLabel';
import DirectLabel from './common/DirectLabel';
import TimeLabel from './common/TimeLabel';
import PlayerSlider from './common/PlayerSlider';
import VideoPlayerControl from './common/VideoPlayerControl';
import {
    CONTROL_EPG,
    CONTROL_LANGUAGE

} from './common/constants';
import PlayerControlsLogic from './PlayerControlsLogic';
import { AAF_CONTENT_IS_TV } from '../../AAFPlayer/constants';
import Utils from '../../utils/Utils';
import ChannelStreamUtil from '../../utils/ChannelStreamUtil';
import TvChannelUtil from '../../utils/TvChannelUtil';
import Translator from '../../requests/apa/Translator';
import { Grid, Row, Column, cls } from '../../packages/components';
import store from '../../store';
import { IPTV } from '../../devices/all/settings';
import { modalInactivityPauseOnLIVE,
modalInactivityPlayOnLIVE, updateValuesStorageMount, updateValuesStorageUnMount } from 'src/components/Modal/functions/ModalInactivity/index'
import LayersControl from 'src/utils/LayersControl';
import logger from 'src/utils/logger/logger';

class PlayerControlsLive extends Component {

    constructor(props) {
        super(props);
        this.epg = this.epg.bind(this);
        this.getCurrentTime = this.getCurrentTime.bind(this);
        this.slide = this.slide.bind(this);
        this.defaultButtons = [
            { type: CONTROL_EPG, clic: this.epg, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_guide', 'Guía'), ref: null, extraClassName: 'video-player-control-main-button' },
            { type: CONTROL_LANGUAGE, clic: props.onLanguage, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_language', 'Idioma') }
        ];
        this.onExit = this.onExit.bind(this)
        this.addEventListeners = this.addEventListeners.bind(this);
        this.removeEventListeners = this.removeEventListeners.bind(this);

        this.updateCurrentTimeUI = this.updateCurrentTimeUI.bind(this);
        this.updateCurrentTime = this.updateCurrentTime.bind(this);
        this.setNormalEventInfo = this.setNormalEventInfo.bind(this);
        this.onEpgSuccess = this.onEpgSuccess.bind(this);

        this.currentTime = 0;

        this.state = {
            normalEventInfo: null // Evento "normal" de TV, osea sin TS, el de TS se llama timeshiftEventInfo
        };

        this.paramsModalInactivity = {
          pause: modalInactivityPauseOnLIVE,
          play: modalInactivityPlayOnLIVE,
          exit : this.props.onExit,
          clearLoading: this.props.clearLoading,
          toggleEPG: this.props.onEpg,
          groupId: this.props.groupId
        }
        this.modalInactivityEnabled = store.getState().modalInactivity.enabled;
        this.setIntervalModalInactivity = this.modalInactivityEnabled ? PlayerControlsLogic.setIntervalModalReproduction(this.paramsModalInactivity) : null;
    }

    onExit() {
      updateValuesStorageUnMount(this.setIntervalModalInactivity)
      this.props.onExit()
      LayersControl.showUX()
    }

    getDefaultEvent() {
        const now = Utils.nowAsTimestampSeconds();
        const date_begin = now - (60 * 60); // now - 1 hr.
        const date_end = now + (60 * 40) // now + 1hr.
        const duration = "02:00:00"; // date_end - date_begin;

        return {
            id: -1,
            title: Translator.get('fallenEvent_epg_notAvialable_label', 'No disponible'),
            date_begin,
            date_end,
            duration,
            group_id: -1,
            max_timeshift: 0,
            type: -1,
            description: 'no disponible'
        };
    }

    isIPTV() {
        const { user: { type = null } = {} } = store.getState();
        if (type === IPTV) {
            return true;
        }

        return false;
    }

    onEpgSuccess() {
        this.props.getNowEvent();
    }

    updateCurrentTime(currentTime) {
        this.setCurrentTime(currentTime);
        this.updateCurrentTimeUI();
    }

    setCurrentTime(currentTime) {
        this.currentTime = currentTime;
    }

    getCurrentTime() {
        return this.currentTime;
    }

    getDuration() {
        if (this.state.normalEventInfo && this.state.normalEventInfo) {
            return (
                this.state.normalEventInfo.date_end -
                this.state.normalEventInfo.date_begin
            );
        }

        return 0;
    }

    getBallPosition(ballPercent) {
        if (this.refs['playerSlider']) {
            const width = this.refs['playerSlider'].refs['barContainer'].offsetWidth;

            if (width < 1) return 0;
            const left = (width * ballPercent) / 100;

            return left;
        }

        return 0;
    }

    updateCurrentTimeUI() {
        let currentTimeUI = this.getCurrentTime();
        // Agregar el incremento
        if (this.state.normalEventInfo) {
            let now = Utils.nowAsTimestampSeconds();
            if (now > this.state.normalEventInfo.date_end) {
                // Pasa al siguiente evento
                // TODO hacer esta misma lógica para <PlayerControlsLiveTS />
                // y esto es para sacar la lógica que tiene abstractHTML5Player
                // TODO Manejar un sólo event en ambos: <PlayerControlsLiveTS /> y <PlayerControlsLive />
                this.props.getNowEvent();
            }
            else {
                //console.log('PAU4> AbstractHTML5Player > Time: ' + Math.round(now - this.currentLiveEvent.date_begin));
                currentTimeUI = Math.round(now - this.state.normalEventInfo.date_begin);
            }
        }

        const ballPercent = PlayerControlsLogic.getPercentProgress(currentTimeUI, this.getDuration());

        if (this.refs['playerSlider']) {
            // % barra avance
            this.refs['playerSlider'].refs['progressNow'].style.width = ballPercent + '%';
            // Time start
            this.refs['timeStart'].refs['time'].innerHTML = PlayerControlsLogic.getContentDuration(currentTimeUI, AAF_CONTENT_IS_TV);
            // Ball position
            this.refs['playerSlider'].refs['ball'].style.left = this.getBallPosition(ballPercent) + 'px';
            // Time end
            // console.log('[NPC] PlayerControls this.refs[playerControls].refs[timeEnd].refs[time].innerHTML', this.refs['playerControls'].refs['timeEnd'].refs['time'].innerHTML);
            this.refs['timeEnd'].refs['time'].innerHTML = PlayerControlsLogic.getContentDuration(this.getDuration(), AAF_CONTENT_IS_TV);
        }
    }

    /**
     * TODO revisar la condición
     */
    isRecordingEnabled() {
        return true;
    };

    /**
     * Resolve enabled buttons
     */
    getVisibleButtons() {
        return this.defaultButtons;
    }

    addEventListeners() {
        this.removeEventListeners();
    }

    removeEventListeners() {
    }

    async componentDidMount() {
        await updateValuesStorageMount(AAF_CONTENT_IS_TV)
        this.addEventListeners();
    }

    resetLiveTimeshift() {
        this.pendingLiveOnPause = null;
        this.timeshiftTime = 0;
        this.waitForSeconds = false;
        this.backwardIsMoving = false;
    }

    componentWillUnmount() {
        this.resetLiveTimeshift();
        if (this.isIPTV()) {
            document.removeEventListener('onEpgSuccessPC', this.onEpgSuccess);
        }
        updateValuesStorageUnMount(this.setIntervalModalInactivity)
    }

    componentWillMount() {
        if (this.isIPTV()) {
            document.removeEventListener('onEpgSuccessPC', this.onEpgSuccess);
            document.addEventListener('onEpgSuccessPC', this.onEpgSuccess);
        }
    }

    componentWillReceiveProps(nProps) {
        let stateEventId = null;
        let propsEventId = null;

        if (nProps && nProps.normalEventInfo && nProps.normalEventInfo.id) {
            propsEventId = nProps.normalEventInfo.id;
        }
        if (this.state.normalEventInfo && this.state.normalEventInfo.id) {
            stateEventId = this.state.normalEventInfo.id;
        }

        if (this.state.normalEventInfo === null && stateEventId === null && propsEventId === null) return;

        if (stateEventId !== propsEventId) {
            this.setState({ normalEventInfo: nProps.normalEventInfo },
                () => {
                    const groupId = nProps.normalEventInfo && nProps.normalEventInfo.group_id ? nProps.normalEventInfo.group_id : '';
                    if (groupId) {
                        const channelInfo = ChannelStreamUtil.get(groupId);
                        const channelNumber = channelInfo ? channelInfo.channel_number || '' : '';
                        const channelImage = channelInfo ? channelInfo.imageEpg || '' : '';
                        const eventTitle = nProps.normalEventInfo && nProps.normalEventInfo.name ? nProps.normalEventInfo.name : '';
                        this.updateChannelInfo(channelNumber, channelImage, eventTitle);
                    }
                }
            );
        }
    }

    /**
    * Update channel info
    */
    updateChannelInfo(channelNumber, channelIcon, eventTitle) {
        if (this.refs['channelInfoLabel']) {
            if (this.refs['channelInfoLabel'].refs['channelNumber']) this.refs['channelInfoLabel'].refs['channelNumber'].innerHTML = channelNumber;
            if (this.refs['channelInfoLabel'].refs['channelImageUrl']) this.refs['channelInfoLabel'].refs['channelImageUrl'].src = channelIcon;
            if (this.refs['channelInfoLabel'].refs['channelEventTitle']) this.refs['channelInfoLabel'].refs['channelEventTitle'].innerHTML = Utils.cutPlayerString(eventTitle, 30, 28);

            if(channelIcon) {
               this.refs['channelInfoLabel'].refs['channelImageUrl'] && this.refs['channelInfoLabel'].refs['channelImageUrl'].classList.remove('channel-info-label-image-hide');
            }
        }
    }

    slide(e) {
        logger.debug('[NPC3] Playercontrols slide events en 1, entrando', this.props.visible, this.props.playing);
        if (!this.props.visible) {
            return false;
        }
        this.props.onSlide(null, direction);
        logger.debug('[NPC3] Playercontrols slide events en 2');
        const { direction } = e.detail;
        switch (direction) {
            case 'left':
            case 'right':
                e.stopPropagation();
                e.preventDefault();
                if(this.props.visible) this.props.hide();
                this.props.showNotificationNoSlide();
            default:
                break;
        }
    }

    focus(where) {
        const resultFocus = this.props.focus(where);
    }

    focusPlayPauseButton(btnClass) {
        this.props.focus(btnClass);
    }

    async performTimeshift(timeshiftData) {
        // Nueva experiencia
        if (this.hasTimeshift()) {
            // Oculta mini y pc
            // this.props.hideMini();
            // this.props.hide();

            this.switchingBetweenEventTimeshift = true;
            logger.debug('[NPC] function performTimeshift > ' + this.switchingBetweenEventTimeshift);
            logger.debug('[NPC] ======================== RESET ============================');
            this.timeshiftTime = 0; // Reset
            const safeTime = this.getSafeTime();
            let _begin = timeshiftData.timeshiftEvent.date_begin + safeTime;
            let _end = timeshiftData.timeshiftEvent.date_end;

            if (this.props.doStartOver && Utils.isFunction(this.props.doStartOver)) {
                this.props.doStartOver(
                    TvChannelUtil.getLastChannel(),
                    _begin,
                    _end,
                    timeshiftData,
                    true
                );
            }
            try {
                if (typeof this.props.onUpdateCurrentTimeshift === 'function') {
                    this.props.onUpdateCurrentTimeshift(this.getCurrentTime());
                }
            } catch (error) {
                logger.error('[NPC] Error on timeshift ', error);
            }
        }
    }

    getSafeTime() {
        const timeshiftMetadata = Utils.getApaMetadataKey('epg_event_safe_time', '{}', 'timeshift');

        if (timeshiftMetadata) {
            return timeshiftMetadata.start;
        }
        else {
            return 0;
        }
    }

    setNormalEventInfo(normalEventInfo) {
        let timeshiftAllowed = 0, channelNumber = '', channelImage = '', eventTitle = '';
        const groupId = normalEventInfo && normalEventInfo.event ? normalEventInfo.event.group_id || '' : '';

        if (groupId) {
            const channelInfo = ChannelStreamUtil.get(groupId);
            channelNumber = channelInfo ? channelInfo.channel_number || '' : '';
            channelImage = channelInfo ? channelInfo.imageEpg || '' : '';
            timeshiftEventInfo.channelTimeshiftAllowed = timeshiftAllowed;
        }
        eventTitle = normalEventInfo && normalEventInfo.event && normalEventInfo.event.name ? normalEventInfo.event.name : '';

        this.setState({ normalEventInfo }, () => {
            this.updateChannelInfo(channelNumber, channelImage, eventTitle);
        });
    }

    /**
     * Clic en botón epg
     */
    epg() {
        this.props.onEpg();
    }

    render() {
        logger.debug('[NPC2] PC TV render ', this.state.timeshiftEventInfo);
        const visibleButtons = this.getVisibleButtons();

        let defLength = 3;
        let controlsClassName = '';
        if (Array.isArray(visibleButtons)) {
            defLength = visibleButtons.length;
            controlsClassName = `player-controls-width-${defLength}`;
        }

        let ct = 1;

        const currentEvent = this.state.normalEventInfo || this.getDefaultEvent();

        return (
            currentEvent ?
                <div>
                    <Grid className="player-controls-live-container">
                        <Row className="player-controls-live-channelinfo-wrapper">
                            <ChannelInfoLabel ref="channelInfoLabel" />
                        </Row>

                        <Row className="player-controls-live-flex-slider-wrapper">
                            <Column lg={1} className={cls(``)}>
                                <TimeLabel ref="timeStart" />
                            </Column>
                            <Column lg={9} className={cls(``)}>
                                {/* La barra Bar Total es la que muestra en un startover, la que muestra el progress del evento respecto al now.  */}
                                <PlayerSlider
                                    ref="playerSlider"
                                    withBarTotal={false}
                                    slide={this.slide}
                                    ballPercent={this.props.ballPercent}
                                />
                            </Column>
                            <Column lg={1} className={cls(``)}>
                                <TimeLabel customCss="time-label-custom-end" ref="timeEnd" />
                            </Column>
                            <Column lg={1} className={cls(``)}>
                                <DirectLabel type="aaf_content_is_tv" label={Translator.get('playingLive_eventType_description_presentEvent_label', 'AHORA')} />
                            </Column>
                        </Row>
                        <Row>
                            <div className="player-controls-live-separator"></div>
                        </Row>
                    </Grid>
                    <Grid className={cls(`player-controls-live-no-grid-float`)}>
                        <Row className={cls(`player-controls-live-flex-controls-wrapper ${controlsClassName}`)}>
                            {
                                visibleButtons.map((button, idx, items) => <VideoPlayerControl
                                    control={button}
                                    onClic={button.clic}
                                    key={`control_${ct++}`}
                                    id={`pc${idx}`}
                                    nav={this.props.getPlayerControlsButtonNavigation(idx, items, true)}
                                />
                                )
                            }
                        </Row>
                    </Grid>
                </div>
                :
                <div className="player-controls-live-container"></div>
        )
    }
}

export default PlayerControlsLive;



// WEBPACK FOOTER //
// ./src/playerDomain/components/PlayerControlsLive.js